exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.row-item-transparent-with-border[data-v-2d2bc89f]{padding:58px 0;cursor:pointer}.total-section[data-v-2d2bc89f]{background-color:#0c2340;border-bottom:2px solid #ffc72c}.total-section h4[data-v-2d2bc89f]{color:#fff}", ""]);

// exports
